<template>
  <div class="lokakarya">
    <v-card flat>
      <v-card-title class="py-0">
        <base-table-header
          :options="{ header: 'py-2' }"
          :btnAdd="false"
          :btnDownload="false"
          :btnReload="false"
          :searchInput="false"
        >
          <template v-slot:subtitle>
            <div class="body-1 black--text">
              Daftar Laporan Pendampingan Kelompok
            </div>
          </template>
          <template v-slot:toolbar>
            <div style="max-width: 350px">
              <v-row no-gutters>
                <v-col cols="12" lg="6" class="py-2 pr-1">
                  <v-select
                    v-model="gelombang"
                    light
                    flat
                    dense
                    outlined
                    hide-details
                    :items="mGelombang"
                    @change="onChangeGelombang"
                  ></v-select>
                </v-col>
                <v-col cols="12" lg="6" class="py-2">
                  <v-select
                    v-model="tahun_ke"
                    light
                    flat
                    dense
                    outlined
                    hide-details
                    :items="mTahun()"
                    @change="onChangeTahun"
                  ></v-select>
                </v-col>
              </v-row>
            </div>
          </template>
        </base-table-header>
      </v-card-title>
    </v-card>
    <div ref="list" :is="component" :tahun_ke="tahun_ke" :gelombang="gelombang"></div>
  </div>
</template>

<script>
import list from '@mixins/list';
import KpLokakarya from './list/KpLokakarya';
import KpPaLokakarya from './list/KpPaLokakarya';
import { mapState } from 'vuex';
export default {
  components: { KpLokakarya, KpPaLokakarya },
  mixins: [list],
  data() {
    return {
      component: 'KpPaLokakarya',
      gelombang: null,
      tahun_ke: null,
    };
  },
  computed: {
    ...mapState('preferensi', {
      paStatus: (state) => state.data?.pelatih_ahli_status ?? {},
      pa: (state) => state.data?.pelatih_ahli ?? {},
      gelombangPendampingan: (state) => (state.data?.pelatih_ahli_gelombang ?? []).sort().reverse(),
      configPendampingan: (state) => (state.data && state.data.pendampingan && state.data.pendampingan['kp-pa']) || {},
      perangkat: (state) => (state.menu && state.menu.perangkat) || {},
    }),

    mGelombang() {
      const gelombangs = this.gelombangPendampingan;
      return gelombangs.map((value) => {
        return {
          text: `Angkatan ${value}`,
          value,
        };
      });
    },

    componentList() {
      return this.paStatus.is_kp_pa_lokakarya ? 'KpPaLokakarya' : 'KpLokakarya';
    },
  },
  created() {
    if (!this.gelombang) {
      const gelombangs = this.gelombangPendampingan;
      this.gelombang = gelombangs[0] || 1;
    }

    if (!this.tahun_ke) {
      this.tahun_ke = this.$getDeepObj(this.configPendampingan, `tahun_ke.${this.gelombang}`);
    }

    this.component = this.componentList;
  },
  methods: {
    mTahun() {
      const gelombangs = this.gelombangPendampingan;
      const gelombang = gelombangs[0] || 1;
      const maxTahun = this.$getDeepObj(this.configPendampingan, `tahun_ke.${this.gelombang || gelombang}`);
      let result = [];

      for (let i = maxTahun; i > 0; i--) {
        result.push({ text: `Tahun ke-${i}`, value: i });
      }

      return result;
    },

    onChangeGelombang(value) {
      this.gelombang = value;
      this.tahun_ke = this.$getDeepObj(this.configPendampingan, `tahun_ke.${this.gelombang}`);
      this.onChangeComponent();
    },

    onChangeTahun(value) {
      this.tahun_ke = value;
      this.onChangeComponent();
    },

    onChangeComponent() {
      let component = '';

      if (+this.gelombang === 1 && +this.tahun_ke === 1) {
        component = 'KpLokakarya';
      } else {
        component = 'KpPaLokakarya';
      }

      if (this.component !== component) {
        this.component = component;
        return;
      }

      this.$nextTick(() => {
        this.$refs.list.fetchData();
      });
    },

    onGetConfig(values) {
      this.tahun_ke = values.tahun_ke;
    },
  },
};
</script>
